import type { ReactNode } from 'react';
import { motion } from 'motion/react';
import { tween } from './presets';
import { useReducedMotion } from './useReducedMotion';

export type PageTransitionProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Transition de page (spec 05 §5.1) : opacity + y:8→0 en `--dur-base`,
 * rejouée au changement de `key` — ENTRÉE seule. Ne pas replacer dans un
 * `<AnimatePresence mode="wait">` : son exit s'est bloqué deux fois (layoutId
 * partagé, updates d'un enfant à clé fixe) en laissant la page à opacity 0.
 * Reduced-motion → opacité seule (pas de translation).
 */
export function PageTransition({ children, className }: PageTransitionProps) {
  const reduced = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduced ? { opacity: 0 } : { opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={reduced ? { opacity: 0 } : { opacity: 0, y: -8 }}
      transition={reduced ? { duration: 0.01 } : tween.base}
    >
      {children}
    </motion.div>
  );
}
